<template>
    <MainContainer :container="!xs" background="lightGrey" :footer="false" :style="xs ? 'padding-bottom: 80px' : ''">

        <template slot="header">
            <div class="bg-white bb b--light-gray">
                <div class="container">
                    <SearchBar class="col-xs-12"/>
                </div>
            </div>
        </template>

        <div class="row mv3 mv4-ns">
            <div :class="{'w-100' : xs, 'col-xs-12' : !xs}" class="col-md-7">
                <Results/>
            </div>
            <div class="col-xs-12 col-md-5 dn dib-m dib-l">
                <Filters/>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import Spinner from 'vue-simple-spinner';
import SearchBar from '@/components/global/SearchBar.vue';
import Filters from './Filters.vue';
import Results from './Results.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        MainContainer,
        Spinner,
        SearchBar,
        Filters,
        Results
    },
    computed: {
        ...mapState('listings', ['resultCount']),
        xs() {
            return this.$mq === 'xs';
        }
    },
    methods: {
        ...mapActions('listings', ['getSearchResults'])
    },
    watch: {
        '$route.query'() {
            this.getSearchResults(this.$route.query);
        }
    },
    created: function() {
        this.getSearchResults(this.$route.query);
    }
};
</script>

<style>
.background {
    background-image: url('../../assets/img/tooliaba_seemless_texture_1.jpg');
    background-repeat: repeat;
}
</style>
